import request from '@/http/http'
export function getPermissions(query) {
  return request({
    url: 'api/permission-management/permissions',
    params: query,
    method: "get"
  })
}
export function updataPermissions(query,data){
  return request({
    url:"/api/permission-management/permissions",
    params: query,
    method: "put",
    data
  })
}